
export const createInvestTaxSummary = (currentYearHistory, investType, gameYear) => {
  
    let regularIncomeAmt = 0;
    let capitalIncomeAmt = 0;
    for (let i=0; i<currentYearHistory.length; i++){
        const transaction = currentYearHistory[i];
        const yearBought = transaction.dateBought.split("-")[0];
        const tranType = transaction.tranType;
        if (tranType === "dividend" || tranType === "coupon" || yearBought === gameYear){
            regularIncomeAmt += +transaction.totalGainLoss;
        }else{
            capitalIncomeAmt += +transaction.totalGainLoss;
        }
    }
    const taxSummary = {investType: investType, regularIncomeAmt: regularIncomeAmt, 
        capitalIncomeAmt: capitalIncomeAmt};
        
    return taxSummary;
}
    
export default createInvestTaxSummary;